import styled from 'styled-components';
import SortSvg from 'library/icons/sort.svg';
import { BaseFormElementStyle } from 'library/components/form-components';
import Dropdown from 'library/components/form-components/dropdown2';
import { withColor } from 'util/hoc';

export const SortIcon = styled(SortSvg)`
  font-size: 1.2em;
  width: 1em;
  height: 1em;
`;

export const StyledSortContainer = styled.div`
  width: 100%;
  min-width: 200px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.5em;
`;

export const StyledSortInnerContainer = styled.div`
  display: inline-flex;
  width: 100%;
  align-items: center;

  label {
    font-size: 14px;
  }

  .sort-dropdown-content {
    padding: 0.5em 0;
    top: 3.2em;
  }

  ${SortIcon} {
    margin-right: -1.5em;
    font-size: 24px;
    ${(props) => !props.propagateClick && `z-index: 1;`}
  }
`;

export const StyledSortOption = withColor(styled.li`
  ${(props) =>
    props.active && `background-color: ${props.theme.colors.grey100};`}
  font-size: 13px;
  line-height: 30px;
  text-align: center;
  font-weight: bold;

  &[aria-selected] {
    background-color: ${(props) => props.theme.colors.grey100};
  }

  &.focus {
    background-color: ${(props) => props.theme.colors.grey100};
  }
`);

export const StyledSortDropdown = withColor(styled(Dropdown)`
  ${BaseFormElementStyle}
  border-radius: 4px;
  width: 100%;
  padding: 0.8em 0.2em 0.8em 3em;
  font-size: 14px;

  &:hover,
  &:focus {
    > svg {
      color: #207c9d;
    }
  }

  &:focus-within {
    outline: solid 2px highlight;
  }

  &:invalid {
    color: red;
  }
  &:disabled {
    border: 1px solid grey;
    cursor: not-allowed;
  }

  button {
    border: none;
    padding: 0 0 0 0.5em;
    height: unset;
    &:not(:disabled):focus {
      outline: none;
    }
  }
`);
